<template>
  <div>
    <h1>{{ tituloh1 }}</h1>
    <div class="my-3">
      <div v-if="firmantespredefinidos && firmantespredefinidos.length">
        <b-card>
          <b-form-group class="mb-4" label-cols-lg="3" label-class="font-weight-bold pt-0" label="Firmantes del documento" description="">
            <b-form-checkbox-group v-model="firmantesseleccionados" :options="optFirmantes" stacked></b-form-checkbox-group>
          </b-form-group>
        </b-card>
      </div>
      <div v-else>
        <b-form-group>
          <b-form-tags size="lg" v-model="seleccion" :limit="limiteDeFirmantes" add-on-change no-outer-focus class="mb-2">
            <template v-slot="{ tags, disabled, addTag, removeTag }">
              <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
                <li v-for="tag in tags" :key="tag" class="list-inline-item">
                  <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled" variant="info" limit-tags-text="Has alcanzado el límite de firmantes de un documento">{{ tag }}</b-form-tag>
                </li>
              </ul>

              <div class="d-flex w-100 justify-content-between">
                <b-dropdown size="lg" variant="outline-secondary" block menu-class="w-100" style="width: 48%; margin-right: 2%">
                  <template v-slot:button-content> <b-icon icon="person-plus-fill"></b-icon> Añadir persona(s) de Manusa </template>
                  <b-dropdown-form @submit.stop.prevent="() => {}">
                    <b-form-group label-for="tag-search-input" label="Filtrar por nombre" label-cols-md="auto" class="mb-0" label-size="sm" :description="searchDesc" :disabled="disabled">
                      <b-form-input v-model="search" id="tag-search-input" type="search" size="sm" autocomplete="off" placeholder="Selecciona una persona de la lista para continuar" debounce="300"></b-form-input>
                    </b-form-group>
                  </b-dropdown-form>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button v-for="option in availableOptions" :key="option.email" @click="onOptionClick({ option, addTag })"> {{ option.nombre }} &lt;{{ option.email }}&gt; </b-dropdown-item-button>
                  <b-dropdown-text v-if="availableOptions.length === 0"> No hay coincidencias para seleccionar </b-dropdown-text>
                </b-dropdown>

                <b-dropdown size="lg" variant="outline-secondary" block menu-class="w-100" class="w-50">
                  <template v-slot:button-content> <b-icon icon="person-plus-fill"></b-icon> Añadir firmante(s) externos a Manusa </template>
                  <b-dropdown-form @submit.stop.prevent="() => {}">
                    <b-input-group prepend="Nombre" class="mb-2">
                      <b-form-input type="text" name="nombre" placeholder="Indica el nombre completo" aria-label="Nombre completo" v-model="ext_nombre"></b-form-input>
                    </b-input-group>
                    <b-input-group prepend="Email" class="mb-2">
                      <b-form-input type="email" name="email" placeholder="Indica el email" aria-label="Email" v-model="ext_email"></b-form-input>
                    </b-input-group>
                    <b-input-group prepend="Línea #1" class="mb-2">
                      <b-form-input type="text" placeholder="(opcional) p.e. cargo" aria-label="Línea #1" v-model="ext_cargo"></b-form-input>
                    </b-input-group>
                    <b-input-group prepend="Línea #2" class="mb-2">
                      <b-form-input type="text" placeholder="(opcional) p.e. representa a..." aria-label="Línea #2" v-model="ext_representacion"></b-form-input>
                    </b-input-group>
                    <b-button @click="onCrearfirmanteexterno({ addTag })">
                      <b-icon-plus-square-fill></b-icon-plus-square-fill>
                      Añadir a firmantes
                    </b-button>
                  </b-dropdown-form>
                </b-dropdown>
              </div>
            </template>
          </b-form-tags>
        </b-form-group>
      </div>
    </div>

    <div class="w-100 d-flex justify-content-between mb-4">
      <b-button @click="pasoatras" variant="danger">
        <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
        Atrás
      </b-button>
      <b-button :disabled="!sepuedecontinuar" @click="siguientepaso" class="bgcolor-manusa">
        Siguiente
        <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'SeleccionFirmantes',
  props: {
    tituloh1: {
      type: String,
      default: 'Indica qué personas firmarán el documento'
    },
    firmantespredefinidos: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      optFirmantes: [],
      firmantesseleccionados: [],

      options: [],
      search: '',
      seleccion: [],
      ext_nombre: '',
      ext_email: '',
      ext_cargo: '',
      ext_representacion: '',
      limiteDeFirmantes: 20
    };
  },
  computed: {
    ...mapGetters({
      vuexTokenUsuario: 'user/token'
    })
  },
  mounted() {
    if (this.firmantespredefinidos) {
      this.optFirmantes = [];
      this.firmantespredefinidos.forEach((f) => {
        this.optFirmantes.push({ value: f, text: f.nombre });
      });
    }

    this.options = [];
    var _t = this;
    this.axios
      .post(
        '/efirma/accion',
        { accion: 'adsi/users/s/solo-manusa', method: 'GET', resptype: 'text' },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.vuexTokenUsuario}`
          }
        }
      )
      .then(function (response) {
        ////console.log(response);
        response.data.forEach((u) => {
          _t.options.push({
            nombre: u['Nombre Completo'],
            email: u['Email'],
            departamento: u['Departamento'],
            delegacion: u['Delegación'],
            empresa: u['Empresa'],
            cargo: u['Departamento'],
            delegacion: u['Delegación'],
            representacion: u['Empresa']
          });
        });
      })
      .catch(function (error) {
        console.log('SeleccionFirmantes - error', error);
      })
      .then(function () {
        // always executed
      });
  },
  computed: {
    sepuedecontinuar() {
      return this.firmantesseleccionados.length || this.seleccion.length;
    },
    criteria() {
      // Compute the search criteria
      return this.search.trim().toLowerCase();
    },
    availableOptions() {
      ////console.log("inicio availableoptions")
      const criteria = this.criteria;
      // Se descartan los que ya están seleccionados
      const options = this.options.filter((opt) => this.seleccion.indexOf(opt.nombre + ' (' + opt.email + ')') === -1);
      if (criteria) {
        // Se filtra segun criterio y se muestran como máximo 6 coincidencias
        return options.filter((opt) => opt.nombre.toLowerCase().indexOf(criteria) > -1).slice(0, 5);
      }
      // Si no hay ningun criterio, se devuelve array en blanco
      return [];
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return 'No hay coincidencias según criterio de búsqueda';
      }
      return '';
    }
  },
  // watch: {
  //     seleccion(newVal) { //, oldVal
  //         // Set the dirty flag on first change to the tags array
  //         ////console.log("watch-seleccion-inicio", newVal, oldVal)
  //         let seleccion = []
  //         newVal.forEach(v => {
  //             let s = this.options.filter(opt => opt.nombre === v)[0]
  //             seleccion.push(s)
  //         })
  //         //this.$emit('actualizar-firmantes', seleccion) //.slice(0,newVal.length-1))
  //         ////console.log("watch-seleccion-fin", seleccion)
  //     }
  // },
  methods: {
    siguientepaso() {
      if (!this.firmantespredefinidos) {
        this.firmantesseleccionados = [];
        this.seleccion.forEach((s) => {
          let opt = this.options.filter((opt) => opt.nombre + ' (' + opt.email + ')' === s)[0];
          let f = {
            cargo: opt.cargo,
            email: opt.email,
            empresa: opt.empresa,
            esexterno: opt.empresa == 'EXTERNO',
            modofirma: 'manuscrita',
            nombre: opt.nombre,
            representa: opt.representacion,
            selloempresa: 'sinsello',
            tratamiento: '',
            tratamientolargo: '',
            departamento: opt.departamento,
            delegacion: opt.delegacion
          };
          this.firmantesseleccionados.push(f);
        });
      }
      console.log(this.firmantesseleccionados);
      this.$emit('firmantes-seleccionados', this.firmantesseleccionados);
    },
    pasoatras() {
      this.$emit('paso-atras');
    },

    onOptionClick({ option, addTag }) {
      addTag(option.nombre + ' (' + option.email + ')');
      this.search = '';
    },
    onCrearfirmanteexterno({ addTag }) {
      addTag(this.ext_nombre + ' (' + this.ext_email + ')');
      this.options.push({
        nombre: this.ext_nombre,
        email: this.ext_email,
        cargo: this.ext_cargo,
        representacion: this.ext_representacion,
        empresa: 'EXTERNO'
      });
      this.ext_nombre = '';
      this.ext_email = '';
      this.ext_cargo = '';
      this.ext_representacion = '';
    }
  }
};
</script>
<style scoped>
.badge-info {
  background-color: #4256f9 !important;
  color: white;
}
.btn-outline-secondary:hover {
  color: #fff !important;
  background-color: #1d6db5 !important;
  border-color: #1d6db5 !important;
}
</style>
